define('lq/services/application/pullDownEvents',[
    'lq/pullDownAction'
], function (pullDownAction) {
    'use strict';

    function PullDownEvents() {
    };

    PullDownEvents.typeName = 'PullDownEvents';

    PullDownEvents.prototype.initialize = function (app) {
        if (window !== window.parent) return;

        pullDownAction.attach(app.$app, app.$wrapper, function () {
            if (app.action.isEventEnabled('pullDown')) {
                app.action.triggerEventIfEnabled('pullDown');
            } else {
                window.location.reload();
            }
        });
    };

    return PullDownEvents;
});
